<template>
  <div class="checkbox-container">
    <input
      type="checkbox"
      :id="id"
      :checked="modelValue"
      @change="updateValue"
      @keydown.space.prevent="toggleCheck"
      class="checkbox"
      :class="additionalClass"
      :aria-checked="modelValue"
      :aria-labelledby="ariaLabelledby"
      :aria-describedby="ariaDescribedby"
    />
    <label
      :for="id"
      class="checkbox-label"
    >
      <svg class="checkbox-icon">
        <use :xlink:href="`#${checked}`" />
      </svg>
      <slot></slot>
      <span
        v-if="modelValue"
        class="checkbox-icon"
      ></span>
    </label>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from 'vue'
  import checked from '@/assets/icons/checked.svg'

  export default defineComponent({
    name: 'Checkbox',
    props: {
      id: {
        type: String,
        required: true,
      },
      additionalClass: {
        type: String,
        required: false,
      },
      modelValue: {
        type: Boolean,
        required: true,
      },
      ariaLabelledby: {
        type: String,
        required: false,
      },
      ariaDescribedby: {
        type: String,
        required: false,
      },
    },
    emits: ['update:modelValue'],
    methods: {
      updateValue(event: Event) {
        const target = event.target as HTMLInputElement
        this.$emit('update:modelValue', target.checked)
      },
      toggleCheck() {
        this.$emit('update:modelValue', !this.modelValue)
      },
    },
    setup() {
      return {
        checked,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .checkbox {
    flex-shrink: 0;
    width: 23px;
    height: 23px;
    border: 1px solid $clr-primary-100;
    border-radius: $border-radius-small;
    cursor: pointer;
    position: relative;
    appearance: none;
    outline: none;

    &-container {
      display: flex;
      align-items: center;
      position: relative;
      text-align: left;
    }

    &--headline + .checkbox-label {
      @include headline-small;
      font-size: rem(18);
    }

    &:checked + .checkbox-label .checkbox-icon {
      display: block;
    }

    &:focus {
      outline: 2px solid $clr-primary;
    }

    &--red:checked {
      background-color: $clr-secondary;
      outline-color: $clr-secondary;
      border-color: $clr-secondary;

      + .checkbox-label .checkbox-icon {
        color: white;
      }
    }

    &-label {
      flex-grow: 1;
      display: flex;
      align-items: center;
      margin-left: 8px;
      cursor: pointer;
    }

    &-icon {
      display: none;
      position: absolute;
      width: 16px;
      height: 16px;
      left: 8px;
    }
  }
</style>
